import { deleteApi, getApi, postApi } from 'apis';

const getDefaultTimeLogs = async (data: any) => {
	return await getApi('/timeLogs', data);
};

const createTimeLogs = async (data: any) => {
	return await postApi('/timeLogs', data);
};

const getTimeActivities = async (data: any) => {
	return await getApi('/timeActivities', data);
};


const sendEmailReminders = async (data: any) => {
	return await postApi('/timeLogs/email-reminder', data);
};

const uploadAttachment = async (data: any) => {
	return await postApi('/timeLogs/upload-attachment', data, true);
};

const deleteAttachment = async (fileName: string) => {
	return await deleteApi(`/api/attachments/${fileName}`);
};

const getMonthlyTimeLogs = async (data: any) => {
	return await getApi('/timeLogs/monthly-time-logs', data);
};

const createMonthlyTimeLogs = async (data: any) => {
	return await postApi('/timeLogs/monthly-time-logs', data);
};

const viewTimeLogsApi = async (data: any) => {
	return await getApi('/shift/view-time-logs', data);
};

const adjustTimeLogsApi = async (data: any) => {
	return await postApi('/adjustment/logs', data);
};

const adjustTimeLogsPostApi = async (data: any) => {
	return await postApi('/adjustment/employee', data);
};

export const timeLogsApi = {
	getDefaultTimeLogs,
	createTimeLogs,
	getTimeActivities,
	sendEmailReminders,
	uploadAttachment,
	deleteAttachment,
	createMonthlyTimeLogs,
	getMonthlyTimeLogs,
	viewTimeLogsApi,
	adjustTimeLogsApi,
	adjustTimeLogsPostApi,
};
